import React, { memo } from 'react';
import * as PropTypes from 'prop-types';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';
import LoopIcon from '@material-ui/icons/Loop';

function ContinueButton({ onClick, displayIn, buttonClass, loading }) {
  const { Button, Fade } = useUiContext();

  if (!displayIn) return null;

  return (
    <Fade in={displayIn}>
      <div className={`form-btn ${buttonClass}`}>
        <Button fullWidth onClick={onClick} disabled={loading}>
          {!loading ? 'Book' : (
            <span className="loading-icon">
              <LoopIcon />
            </span>
          )}
        </Button>
      </div>
    </Fade>
  );
}

ContinueButton.defaultProps = {
  displayIn: true,
  buttonClass: '',
  loading: false,
};

ContinueButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  displayIn: PropTypes.bool,
  buttonClass: PropTypes.string,
  loading: PropTypes.bool,
};

export default memo(ContinueButton);
